import { memo } from "react";

import type { RequestFilterType } from "../../../types/filters";

import { overdueTableConfig } from "../../../config/tables/superadmin/overdueTableConfig";
import { UnifiedSuperAdminTab } from "./UnifiedSuperAdminTab";

interface OverdueTabProps {
  lazyLoadingConfig?: {
    currentTab: string;
    enabled: boolean;
  };
  searchValue?: string;
  selectedFilter?: RequestFilterType;
}

function OverdueTabComponent(props: OverdueTabProps) {
  return (
    <UnifiedSuperAdminTab
      {...props}
      tableConfig={overdueTableConfig}
      tabType="overdue"
    />
  );
}

export const OverdueTab = memo(OverdueTabComponent);
